export var LineStatus;
(function (LineStatus) {
    LineStatus[LineStatus["INACTIVE"] = 0] = "INACTIVE";
    LineStatus[LineStatus["ACTIVE"] = 1] = "ACTIVE";
})(LineStatus || (LineStatus = {}));
//# sourceMappingURL=lines-settings.i.js.map